import {PillStatus} from "@/components/statusPill/StatusPill.types.ts";
import {MonitoringServiceType, Service} from "@/lib/types/checks.ts";
import {MonitoringServer} from "@/lib/types/monitoring.ts";
import {NetworkProbeResult} from "@/lib/types/network.ts";
import {BrowserConsoleMessage, TxnNetworkResult, TxnResult} from "@/lib/types/transaction.ts";

export enum AlertState {
  // Services
  OK = "OK",
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
  UNKNOWN = "UNKNOWN",

  // Devices
  UP = "UP",
  DOWN = "DOWN",
  UNREACHABLE = "UNREACHABLE",

  // Special
  PENDING = "PENDING",
  NOT_CONFIGURED = "NOT_CONFIGURED",
}

export const ALERT_STATE_TO_PILL_STATUS: Record<AlertState, PillStatus> = {
  [AlertState.OK]: PillStatus.OK,
  [AlertState.WARNING]: PillStatus.WARNING,
  [AlertState.CRITICAL]: PillStatus.CRITICAL,
  [AlertState.UNKNOWN]: PillStatus.UNKNOWN,
  [AlertState.UP]: PillStatus.UP,
  [AlertState.DOWN]: PillStatus.DOWN,
  [AlertState.UNREACHABLE]: PillStatus.UNREACHABLE,
  [AlertState.PENDING]: PillStatus.PENDING,
  [AlertState.NOT_CONFIGURED]: PillStatus.NOT_CONFIGURED,
};

export const ALERT_STATUS_TO_PILL_STATUS: Record<string, PillStatus> = {
  down: PillStatus.ONGOING,
  ignored: PillStatus.IGNORED,
  resolved: PillStatus.RESOLVED,
};

export interface Alert {
  id: number;
  created_at: string;
  monitoring_server?: MonitoringServer;
  event_id: number;
  alerted_at: string;
  state: AlertState;
  type: string;
  attempt_number: number;
  output: string;
  is_up: boolean;
}

export interface AlertExtraDataJSON {
  console?: BrowserConsoleMessage[];
  results?: TxnResult[];
  network?: TxnNetworkResult[];
  options?: object[];
  version: string;
}

export interface NetworkAlertData {
  probes: NetworkProbeResult[];
}

export interface AlertExtraData {
  id: number;
  alert?: Alert;
  data?: AlertExtraDataJSON;
  picture?: string;
  gphttp?: NetworkAlertData;
}

export interface GlobalAlertState {
  id: number;
  created_at: Date;
  up_at?: Date;
  duration: number;
  ignored: boolean;
  // Nullable: record_global_alert_state_for_service(..., alert=None) can create an
  // alert-less state (e.g. an initial up-state), so consumers must guard before use.
  alert: Alert | null;
  service: Service;
  service_id: number;
  state_has_changed: boolean;
  state_is_up: boolean;
  num_locations_down: number;
  down_alerts: Alert[];
  // extra to a sub service entity if more fields added
  service_is_deleted: boolean;
  service_monitoring_type: MonitoringServiceType;
  status: string;
}
